import { isValidPhoneNumber } from 'react-phone-number-input';
import urls from "../constants";

function exists(obj) {
  return obj && obj !== undefined && obj !== null;
}

function isEmpty(obj) {
  return !exists(obj) || (obj instanceof Array ? obj.length === 0 : Object.keys(obj).length === 0);
}
function formatDash(value) { return value || "—"; }

const CheckNull = (value) => {
  if (value === null || typeof (value) === "undefined" || value === NaN || value === "")
    return ""
  else
    return value;
}

const isRequired = (value) => {
  const result = value != '' && typeof value === 'string' ? value.trim() : value;
  if (result == '' || result === null || typeof (result) === "undefined" || result === NaN)
    return false;
  else
    return true;
}

const isRequiredNo = (value) => {
  if (value === null || typeof (value) === "undefined" || value === NaN || value === "" || value === 0)
    return false;
  else
    return true;
}

const FormatValueDecimal = (value) => {
  const num = parseFloat(value);
  const parsedValue = (isNaN(num) ? 0 : num).toFixed(2);
  return parsedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const isValidEmail = (value) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (value != "" && regex.test(value) === false) {
    return false;
  } else {
    return true;
  }
}

const isValidPhone = (value) => {
  return isValidPhoneNumber(value)
}

const isAlphaNumeric = (value) => {
  const regex = /^[A-Za-z0-9]*$/;
  if (value != "" && regex.test(value) === false) {
    return false;
  } else {
    return true;
  }
}

const isValidString = (value) => {
  return typeof value === 'string' && !/\d/.test(value) && value.trim() !== "";
}


const isTextOnly = (value) => {
  // let regex = /^[A-Za-z]+$/
  let regex = /^[a-zA-Z]+(?:[\s. ]+[a-zA-Z]+)*$/
  if (value != "" && regex.test(value) === false) {
    return false;
  } else {
    return true;
  }
}

const isValidPassword = (value) => {
  let regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,20}$/;
  if (value != "" && regex.test(value) === false) {
    return false;
  } else {
    return true;
  }
}

const isNumberOnly = (value) => {
  let regex = /^[0-9]*\.*\-?[0-9]+$/;
  const result = value != '' && typeof value === 'string' ? value.trim() : value;
  if (result == '') return false
  else if (result != "" && regex.test(value) === false) {
    return false;
  } else {
    return true;
  }
}

const isPositiveNumberOnly = (value) => {
  let regex = /^(0*[1-9]\d*)(\.\d+)?$/;
  const result = value != '' && typeof value === 'string' ? value.trim() : value;
  if (result == '') return false
  else if (result != "" && regex.test(value) === false) {
    return false;
  } else {
    return true;
  }
}

const isValidUrl = (value) => {
  let regex = /^((http(s?)?):\/\/)?([wW]{3}\.)?[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/g;
  return regex.test(value);
};

const isValidFileUploaded = (file) => {
  const validExtensions = ["png", "jpg"];
  const fileExtension = file?.type.split("/")[1];
  return validExtensions.includes(fileExtension);
};

const isValidFileSize = (file) => {
  const MAX_FILE_SIZE = 500000;
  if (file > MAX_FILE_SIZE) {
    return false;
  } else {
    return true;
  }
};

function isValidFaxNumber(values) {
  const regex = /^\+?[0-9]{6,}$/ // only allowed 9 digits and more
  return regex.test(values);
}

function diffdays(date1, date2) {
  // To calculate the time difference of two dates
  var Difference_In_Time = date2.getTime() - date1.getTime();

  // To calculate the no. of days between two dates
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  return Difference_In_Days;
}

const isValidDate = (value) => {
  if (value === null || typeof (value) === "undefined" || value === "")
    return false;
  else if (new Date(value) === "Invalid Date")
    return false;
  else
    return true;
}

const dateCheck = (value) => {
  if (value === null || typeof (value) === "undefined" || value === "")
    return new Date();
  else if (new Date(value) === "Invalid Date")
    return new Date();
  else
    return new Date(value);
}

function validateName(name) {
  const regex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/; // Regular expression to check if input contains only text
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regular expression to check if input contains email format
  const urlRegex = /(?:https?:\/\/)?(?:www\.)?[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,}/; // Regular expression to check if input contains a URL

  if (name.match(emailRegex)) {
    return "Please enter a valid name and not an email format.";
  } else if (name.charAt(0).match(/\d/)) {
    return "Name should not start with a number.";
  } else if (name.match(urlRegex)) {
    return "Name should not contain a website URL.";
  } else if (!name.match(regex)) {
    return "Name should contain only text.";
  } else {
    return "";
  }
}

function convertLocalToUTCDate(date) {
  if (!date) return date
  date = new Date(date)
  date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
  return date
}


//exclude negative numbers and zero,allow upto 4 decimal places
function isValidConversionRate(values) {
  const reg = /^\d+(\.\d{1,2})?$/;
  return reg.test(values);
}

function getMonthShortName(monthNo) {
  const date = new Date();
  date.setMonth(monthNo);
  return date.toLocaleString('en-US', { month: 'short' });
}


const padDate = (n) => {
  return n < 10 ? '0' + n : n;
}

function formatDate(date, params) {
  let dt = new Date(date);
  if (isNaN(dt.getTime())) {
    return ""; // Invalid Date
  }
  let day = dt.getDate();
  let month = dt.getMonth();
  let monthName = getMonthShortName(month)
  let year = dt.getFullYear();
  let dateObject;
  if (params == "view") {
    dateObject = padDate(day) + "/" + padDate(month + 1) + "/" + year;
  }
  else dateObject = day + '-' + monthName + '-' + year
  return dateObject
}


const compareDates = (date1, date2) => {
  let dateResult;
  const d1 = new Date(date1)
  const d2 = new Date(date2)
  if (d1 > d2) dateResult = false
  else if (d1 < d2) dateResult = true
  else dateResult = false
  return dateResult
}


const isValidAdvancePayment = (value) => {
  const regex = /^[0-9]*[0-9]+[0-9]*$/
  const result = value != '' && typeof value === 'string' ? value.trim() : value;
  if (regex.test(result)) return true
  else return false
}


const getStorageData = () => {
  const userProf = JSON.parse(localStorage.getItem("userProfile"))
  return userProf
}

const getDecimalValue = (pNumber) => {
  if (pNumber === "" || pNumber === null || typeof (pNumber) === "undefined" || pNumber === NaN)
    return 0
  else return Number(pNumber)
}

const AvatarName = (preName) => {
  if (preName) {
    const nameArr = preName?.trim().split(" ")
    if (nameArr.length > 0)
      if (nameArr.length === 1)
        return nameArr[0]?.substring(0, 2).toUpperCase()
      else
        return nameArr[0].substring(0, 1).toUpperCase() + nameArr[1].substring(0, 1).toUpperCase()
    else return ""
  } else return "CC"
}

const PriceCheck = (event, value) => {
  let result = (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46;
  if (result) {
    let t = value;
    if (t === '' && event.charCode === 46) {
      return false;
    }
    let dotIndex = t.indexOf(".");
    let valueLength = t.length;
    if (dotIndex > 0) {
      if (dotIndex + 2 < valueLength) {
        return false;
      } else {
        return true;
      }
    } else if (dotIndex === 0) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

const PriceFormat = (value) => {
  if (value)
    return value?.toLocaleString('en-US', { maximumFractionDigits: 2 })
}

function numberToWords(num, currencyDetail) {
  if (isNaN(num)) return
  const belowTwenty = [
    'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
    'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const tens = [
    '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
  ];
  const thousands = ['', 'Thousand', 'Million', 'Billion'];

  function convertToWords(n) {
    if (n === 0) return '';
    if (n < 20) return belowTwenty[n] + ' ';
    if (n < 100) return tens[Math.floor(n / 10)] + ' ' + convertToWords(n % 10);
    if (n < 1000) return belowTwenty[Math.floor(n / 100)] + ' Hundred ' + convertToWords(n % 100);
    for (let i = 0; i < thousands.length; i++) {
      const unit = 1000 ** (i + 1);
      if (n < unit) {
        return convertToWords(Math.floor(n / (unit / 1000))) + thousands[i] + ' ' + convertToWords(n % (unit / 1000));
      }
    }
    return '';
  }

  function decimalToWords(decimal) {
    if (decimal === 0) return '';
    return decimal.split('').map(digit => belowTwenty[+digit]).join(' ');
  }

  // Separate integer and fractional parts
  const [integerPart, decimalPart] = num.toString().split('.');

  let result = GetCurrencyWords(currencyDetail?.shortCode, false) + " " + convertToWords(parseInt(integerPart));

  // If there is a decimal part, handle it
  if (decimalPart && parseInt(decimalPart) > 0) {
    result += "and " + decimalPart + "/100 only";
  }

  return result.trim();
}

const GetCurrencyWords = (currency, isDecimal) => {
  const currencyMap = {
    USD: { whole: "United States Dollar", decimal: "cents" },
    QAR: { whole: "Qatari Riyals", decimal: "dirhams" },
    OMR: { whole: "Omani Rial", decimal: "baisas" },
    KWD: { whole: "Kuwaiti Dinar", decimal: "fils" },
    SAR: { whole: "Saudi Riyal", decimal: "halalas" },
  };

  return currencyMap[currency]?.[isDecimal ? "decimal" : "whole"] || "";
};


const CurrencyConvertion = (amount, conversionValue, currencyDetail) => {
  let value = 0;
  if (currencyDetail?.shortCode === "QAR") value = amount
  else value = (amount || 0) * (conversionValue || 0)
  const num = parseFloat(value);
  return (isNaN(num) ? 0 : num).toFixed(2)
}

const QatarConvertion = (amount, conversionValue, currencyDetail) => {
  let value = 0;
  if (currencyDetail?.shortCode === "QAR") value = amount
  else value = (amount || 0) / (conversionValue || 0)
  const num = parseFloat(value);
  return (isNaN(num) ? 0 : num).toFixed(2)
}


const ConvertFromBase = (amount, conversionValue, currencyDetail, baseCurrency) => {
  if (!baseCurrency?.id) return CurrencyConvertion(amount, conversionValue, currencyDetail);

  const value = currencyDetail?.id === baseCurrency.id
    ? amount
    : (amount || 0) * (conversionValue || 0);

  const num = parseFloat(value);
  return (isNaN(num) ? 0 : num).toFixed(2);
};

const calculateActuatorNetPrice = (item) => {
  // item = one mark (a product line in the quotation)

  // 1. Only for CFSD (Combination Fire Smoke Damper). Other products skip this.
  if (
    item?.groupId !== urls?.COMBINATION_FIRE_SMOKE_GROUP_ID &&
    item?.groupId !== urls?.SMOKE_DAMPER_GROUP_ID
  ) return null;

  // 2. The size rows of the mark. If there are none, return null.
  const sizeRows = Array.isArray(item?.productItems) ? item.productItems : [];
  if (sizeRows.length === 0) return null;

  // 3. Every row must have both a damper list price and an actuator list price above 0.
  //    If even one row is missing either, return null and the normal calculation is used.
  const allRowsHaveActuator = sizeRows.every(
    (row) =>
      parseFloat(row?.damperListPrice) > 0 &&
      parseFloat(row?.actuatorListPrice) > 0
  );
  if (!allRowsHaveActuator) return null;

  // 4. The mark margin in percent (0 if missing).
  const markMargin = parseFloat(item?.margin) || 0;

  // 5. Helper: round to 2 decimals (EPSILON avoids float errors like 1.005).
  const roundTo2Decimals = (number) =>
    Math.round((number + Number.EPSILON) * 100) / 100;

  // 6. Helper: apply margin or discount to a price.
  //    margin < 0   (discount): price x (1 - discount%)   e.g. -10% -> price x 0.9
  //    margin >= 100          : 0 (avoids divide by zero)
  //    margin > 0             : price / (1 - margin%)     e.g. 10% -> price / 0.9
  const addMarginToPrice = (price, marginPercent) => {
    if (marginPercent < 0) return price * (1 - (-marginPercent / 100));
    if (marginPercent >= 100) return 0;
    return price / (1 - marginPercent / 100);
  };

  // 7. Total of all rows.
  const totalNetPrice = sizeRows.reduce((runningTotal, row) => {
    // Quantity order of preference: quoteQuantity -> quantity -> 1
    const rowQuantity =
      parseFloat(row?.quoteQuantity) ||
      parseFloat(row?.quantity) ||
      1;

    // Damper price with the mark margin (margin applies to the damper only)
    const damperPriceWithMargin = roundTo2Decimals(
      addMarginToPrice(parseFloat(row.damperListPrice), markMargin)
    );

    // Actuator price as it is (it already has its own margin included)
    const actuatorPrice = roundTo2Decimals(parseFloat(row.actuatorListPrice));

    // Unit price = damper (with margin) + actuator
    const unitPrice = damperPriceWithMargin + actuatorPrice;

    // Row total = unit price x quantity, added to the running total
    return runningTotal + unitPrice * rowQuantity;
  }, 0);

  // 8. Final total, rounded to 2 decimals.
  return parseFloat(totalNetPrice.toFixed(2));
};

const calculateNetPrice = (item) => {
  const actuatorNet = calculateActuatorNetPrice(item);
  if (actuatorNet !== null) return actuatorNet;

  const productItemTotal = Array.isArray(item?.productItems)
    ? item.productItems.reduce((sum, pi) => {
      const unitPrice = parseFloat(pi?.unitPrice) || 0;
      const quantity = parseFloat(pi?.quantity) || 0;
      return sum + (unitPrice * quantity);
    }, 0)
    : 0;

  const listPrice = parseFloat(item?.listPrice);
  const margin = parseFloat(item?.margin);
  const safeListPrice = isNaN(listPrice) || listPrice <= 0 ? productItemTotal : listPrice;
  const hasMarginValue =
    item?.margin !== undefined &&
    item?.margin !== null &&
    item?.margin !== "";
  const safeMargin = isNaN(margin) ? 0 : margin;

  if (!hasMarginValue && productItemTotal > 0) {
    return parseFloat(productItemTotal.toFixed(2));
  }

  // Negative margin: listPrice × (1 - (-margin/100))
  if (safeMargin < 0) {
    return parseFloat((safeListPrice * (1 - (-safeMargin / 100))).toFixed(2));
  }

  // Margin >= 100: avoid division by zero, return 0
  if (safeMargin >= 100) return 0;
  // Positive margin: listprice/(1-(margin/100))
  return parseFloat((safeListPrice / (1 - safeMargin / 100)).toFixed(2));
};

export {
  exists,
  isEmpty,
  CheckNull,
  isRequired,
  isValidEmail,
  isValidPhone,
  isTextOnly,
  isValidPassword,
  isNumberOnly,
  isValidUrl,
  isRequiredNo,
  isValidFileUploaded,
  isValidFileSize,
  isValidFaxNumber,
  diffdays,
  isValidDate,
  dateCheck,
  validateName,
  isAlphaNumeric,
  convertLocalToUTCDate,
  isValidConversionRate,
  formatDate,
  compareDates,
  isValidAdvancePayment,
  getStorageData,
  getDecimalValue,
  FormatValueDecimal,
  AvatarName,
  isValidString,
  PriceCheck,
  PriceFormat,
  numberToWords,
  isPositiveNumberOnly,
  CurrencyConvertion,
  QatarConvertion,
  formatDash,
  calculateNetPrice,
  ConvertFromBase,
  calculateActuatorNetPrice,

};